import React, { useState, useEffect } from "react";
import Meta from "../../components/Meta";
import Image from "next/image";
import ContactForm from "../../components/contact/ContactForm";
import Link from "next/link";
import VideoWithTwoTitles from "../../components/world-of-impact/videoWithTwoTitle";
import SecondDescripton from "../../components/common/SecondDescripton";
import Feature_collections from "../../components/collectrions/Feature_collections";
import  common_data from "../../data/common_data";
import WhoIsItFor from "../../components/art-for-impact-campaign/WhoIsItFor";

const WorldOfImpact = () => {
  const [video, setVideo] = useState(false);
  const [partyTime, setPartyTime] = useState(false);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    // Set target date to 30 days from now
    const target = new Date();
    target.setDate(target.getDate() + 30); // 30 days from now

    const interval = setInterval(() => {
      const now = new Date();
      const difference = target.getTime() - now.getTime();

      const d = Math.floor(difference / (1000 * 60 * 60 * 24));
      setDays(d);

      const h = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      setHours(h);

      const m = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      setMinutes(m);

      const s = Math.floor((difference % (1000 * 60)) / 1000);
      setSeconds(s);

      if (d <= 0 && h <= 0 && m <= 0 && s <= 0) {
        setPartyTime(true);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Meta title="Art for Impact Compaigns || Impactoverse" />
   
      <section className="relative pt-[9rem] lg:pb-24 text-center">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
          <Image
            width={1519}
            height={773}
            priority
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <div className="lg:flex lg:space-x-12">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={935}
              src="/images/gradient.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
            <Image
              width={1519}
              height={935}
              src="/images/gradient_dark.jpg"
              alt="gradient dark"
              className="h-full w-full object-cover"
            />
          </picture>
        </div>
        <div className="container mx-auto text-center">
          <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
            Art for
            <span className="animate-gradient"> Impact Compaigns</span>
            <br />
          </h1>
          <h3 className="font-display max-sm:my-5 text-2xl text-jacarta-700 dark:text-white lg:text-2xl xl:text-3xl text-center uppercase">
            Where Creativity Fuels Change
          </h3>
          <SecondDescripton text={`The Impact for Impact platform is where purpose meets creativity to fund impact, build communities, tell stories,and engage people in causes that matter. Whether you’re an artist, campaigner, supporter, or changemaker, build an impact portfolio here.`} lg={15}></SecondDescripton>
          {/* <p className="text-lg dark:text-jacarta-50">
            The Impact for Impact platform is where purpose meets creativity to
            fund impact, build communities, tell stories,
            <br /> and engage people in causes that matter.
            <br />
            Whether you’re an artist, campaigner, supporter, or changemaker,
            build an impact portfolio here.
          </p> */}
        </div>
        {/* <button className=" mx-auto mt-8 px-8 py-4 bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all">
            Explore Campaigns
          </button> */}
      </section>

       <section className="py-16 px-4 sm:px-8 ">
        <div className="max-w-6xl mx-auto">
          <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-8">
          Why Use <span className="animate-gradient"> Art for Impact Campaigns?</span>
        </h1>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {common_data.whyUseArt.map((reason, index) => (
              <div
                key={index}
                className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg flex flex-col items-center"
              >
                <div className="rounded-full w-20 h-20 m-4 flex items-center justify-center bg-accent-dark color-white">
                  {reason.icon}
                </div>
                <h3 className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white uppercase">
                  {reason.title}
                </h3>
                <p className="text-lg dark:text-jacarta-300">
                  {reason.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
 
      <Feature_collections/>
      
      <section className="py-12 px-6 max-w-6xl mx-auto">
        <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-8">
          What Makes <span className="animate-gradient"> This Different?</span>
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {common_data.uniqueFeatures.map((service, index) => (
            <div
              key={index}
              className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg"
            >
              <div className="flex items-center justify-center">
                <div
                  className={`rounded-full w-20 h-20 m-4 flex items-center justify-center ${service.bgColor} color-white`}
                >
                  {service.image}
                </div>
              </div>
              <h3 className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white uppercase">
                {service.title}
              </h3>
              <p className="text-lg dark:text-jacarta-300">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </section>

    
      <WhoIsItFor/>
   


      <section className="pb-0">
        <div className="container">
          <div className="rounded-2.5xl bg-light-base px-10 py-10 text-center dark:bg-jacarta-700">
            <div>
               <h2 className="mb-5 font-extrabold text-3xl sm:text-4xl md:text-5xl leading-tight drop-shadow-md">
              Interested in Launching a Campaign?
            </h2>
            </div>
            
            <p className="mb-8 mx-auto max-w-2xl text-center text-lg text-jacarta-700 dark:text-white">
              Each campaign builds community, raises awareness, and drives
              funding through shared creative power.
            </p>

            <Link
              href="/contact-us"
              target="_blank"
              className="inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark uppercase"
            >
              Request a Demo or Exploratory Call
            </Link>
            <p className="mt-8 text-lg opacity-80 max-w-2xl mx-auto">
              Art isn’t just symbolic, it’s functional. Every contribution,
              sale, share, and story moves a cause forward.
            </p>
          </div>
          <div className="mb-20"></div>
        </div>
      </section>
    </>
  );
};

export default WorldOfImpact;
